import { Form } from '@calendly/form';
import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveOrgVisibilitySettings } from 'actions/current_organization';
import { orgVisibilitySettingsSelector } from 'selectors/current_organization';
import { Description, Question } from '../styles';
import { FormContent } from './form_content';
const customDescriptionCss = "c12okkfx";
const CustomDescription = forwardRef((props, ref) => <Description ref={ref} {...props} className={classNames(customDescriptionCss, props.className)} />);
export const Visibility = () => {
  const {
    available_to_request_to_join: available
  } = useSelector(orgVisibilitySettingsSelector);
  const dispatch = useDispatch();
  const pageTitle = `${I18n.t('publisher.organization_settings.visibility.title')} - ${I18n.t('publisher.admin.security.title')}`;
  usePageTitle(pageTitle);
  return <>
      <FlexLayout direction="column" gap={16}>
        <TitleText level={2} size="medium">
          {I18n.t('publisher.organization_settings.visibility.title')}
        </TitleText>
        <CustomDescription>
          {I18n.t('publisher.organization_settings.visibility.description')}
        </CustomDescription>
      </FlexLayout>
      <Question>
        {I18n.t('publisher.organization_settings.visibility.question')}
      </Question>
      <Form initialValues={{
      available_to_request_to_join: available.toString()
    }} onSubmit={newSettings => dispatch(saveOrgVisibilitySettings(newSettings))}>
        <FormContent />
      </Form>
    </>;
};

require("./visibility.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./visibility.js");